import {
  ComponentFactoryResolver,
  Injectable,
  Injector,
  ViewContainerRef,
} from '@angular/core';

import { DynatraceService } from '@segurosvoluntarios_vel/commons-services';
import { Pago } from 'src/app/pago/models/Pago.model';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { EstadoPago } from 'src/app/pago/enums/EstadoPago.enum';
import { KeyResumenDePago } from 'src/app/pago/enums/KeyResumenDePago.enum';
import { ESTADO_PAGO_COMPONENTS } from 'src/app/pago/const/EstadoPagoComponents';
import { ParamCrearComponenteValidacion } from 'src/app/pago/models/ParamCrearComponenteValidacion.model';

@Injectable({
  providedIn: 'root',
})
export class EstadoPagoBuilderService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private dynatraceService: DynatraceService
  ) {}

  createComponent(
    pago: Pago,
    contenidosEstadosDePago: ContenidoDeEstadoDePago[],
    container: ViewContainerRef,
    tenant: string
  ) {
    container.clear();
    let component;
    const params = {
      pago,
      contenido: this.findContenidoDeEstadoDePago(
        contenidosEstadosDePago,
        pago.estadoPago as EstadoPago
      ),
      tenant,
    };

    console.log(`${KeyResumenDePago.ESTADO}: ${pago.estadoPago}`);
    this.dynatraceService.enterAction(
      `${KeyResumenDePago.ESTADO_PAGO}: ${pago.estadoPago}`
    );

    switch (pago.estadoPago) {
      case EstadoPago.APROBADO:
        component = ESTADO_PAGO_COMPONENTS.APROBADO;
        break;
      case EstadoPago.PENDIENTE:
        component = ESTADO_PAGO_COMPONENTS.PENDIENTE;
        break;
      default:
        component = ESTADO_PAGO_COMPONENTS.RECHAZADO;
        break;
    }

    this.initComponent(component, params, container);
  }

  findContenidoDeEstadoDePago(
    contenidosDeEstadosDePago: ContenidoDeEstadoDePago[],
    estadoPago: EstadoPago
  ): ContenidoDeEstadoDePago {
    return contenidosDeEstadosDePago.find(
      (contenidoEstadoDePago: ContenidoDeEstadoDePago) =>
        contenidoEstadoDePago.estado.toLocaleLowerCase() ===
        estadoPago.toLocaleLowerCase()
    );
  }

  private initComponent(
    component: any,
    params: ParamCrearComponenteValidacion,
    container
  ): void {
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      component
    );
    const ComponentContentInjector = Injector.create({
      providers: [],
      parent: this.injector,
    });
    const ref = container.createComponent(
      factory,
      undefined,
      ComponentContentInjector
    );

    if (params) {
      Object.keys(params).forEach(key => {
        ref.instance[key] = params[key];
      });
    }

    ref.changeDetectorRef.detectChanges();
  }
}
